import { createContext, useContext } from 'react';

import type { Config } from 'src/types/types';

const AppConfigContext = createContext<Config>({
  appName: 'candidate-basic-search-ui',
  site: 'candidate-seek-au',
  environment: 'development',
  isAuthenticated: false,
  client: 'browser',
  branchName: 'local',
  brand: 'seek',
  country: 'AU',
  appVersion: '',
});

interface AppConfigProviderProps {
  config: Config;
  children: React.ReactNode;
}

export const AppConfigProvider = ({
  config,
  children,
}: AppConfigProviderProps) => (
  <AppConfigContext.Provider value={config}>
    {children}
  </AppConfigContext.Provider>
);

export const useAppConfig = () => {
  const context = useContext(AppConfigContext);
  if (!context) {
    throw new Error('useAppConfig must be used within an AppConfigProvider');
  }
  return context;
};
